
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.75 9a6.75 6.75 0 1 1-13.5 0 6.75 6.75 0 0 1 13.5 0Zm1.5 0A8.25 8.25 0 1 1 .75 9a8.25 8.25 0 0 1 16.5 0Zm-12.3.44v.798h.934c.196.798.592 1.434 1.187 1.91.595.47 1.344.704 2.247.704.882 0 1.603-.213 2.163-.64.567-.428.92-1.019 1.06-1.775h-1.48a1.492 1.492 0 0 1-.588.893c-.294.21-.683.315-1.166.315-.497 0-.917-.123-1.26-.368-.343-.245-.591-.591-.745-1.04h2.184V9.44H7.134a6.45 6.45 0 0 1 0-.767h2.352v-.809H7.302c.161-.44.41-.784.745-1.029.343-.245.763-.367 1.26-.367.483 0 .872.115 1.166.346.301.224.497.536.588.935h1.48c-.14-.791-.493-1.403-1.06-1.837-.56-.441-1.281-.662-2.163-.662-.903 0-1.652.238-2.247.714-.588.476-.98 1.11-1.176 1.9H4.95v.809h.819a3.517 3.517 0 0 0 0 .767H4.95Z","fill":"#B0B9C1"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    